<template>
    <v-card tile>
        <v-card-text>
            <div 
                v-if="products.length === 0" 
                class="text-center py-8"
            >
                <v-icon 
                    size="64" 
                    color="grey-lighten-1"
                >
                    mdi-package-variant-closed
                </v-icon>
                <p class="text-body-1 mt-4 text-grey">
                    Nenhum produto ativo encontrado
                </p>
            </div>

            <v-row v-if="products.length > 0">
                <v-col 
                    v-for="item in products" 
                    :key="item.id"
                    cols="12"
                    md="6"
                    lg="4"
                >
                    <v-card 
                        outlined
                        class="h-100"
                    >
                        <v-card-title class="text-subtitle-1 d-flex">
                            <div class="grow">
                                {{ item.product.name }}
                            </div>
                            <r-chip-status
                                :value="item.status"
                                :items="$subscription.statuses"
                                small 
                            />
                        </v-card-title>
                        <v-divider />
                        
                        <v-card-text>
                            <v-list 
                                density="compact" 
                                class="pa-0"
                            >
                                <v-list-item class="px-0">
                                    <v-list-item-title class="text-caption">
                                        Preço
                                    </v-list-item-title>
                                    <v-list-item-subtitle class="text-h6 text-success">
                                        {{ item.pricing_schema.short_format }}
                                    </v-list-item-subtitle>
                                </v-list-item>

                                <v-list-item class="px-0">
                                    <v-list-item-title class="text-caption">
                                        Quantidade
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        {{ item.quantity }}
                                    </v-list-item-subtitle>
                                </v-list-item>

                                <v-list-item class="px-0">
                                    <v-list-item-title class="text-caption">
                                        Usos
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        {{ item.uses }}
                                    </v-list-item-subtitle>
                                </v-list-item>

                                <v-list-item 
                                    v-if="item.cycles"
                                    class="px-0"
                                >
                                    <v-list-item-title class="text-caption">
                                        Ciclos
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        {{ item.cycles }}
                                    </v-list-item-subtitle>
                                </v-list-item>

                                <v-list-item class="px-0">
                                    <v-list-item-title class="text-caption">
                                        Tipo de Preço
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        {{ item.pricing_schema.schema_type }}
                                    </v-list-item-subtitle>
                                </v-list-item>

                                <v-list-item 
                                    v-if="item.product.code"
                                    class="px-0"
                                >
                                    <v-list-item-title class="text-caption">
                                        Código
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        {{ item.product.code }}
                                    </v-list-item-subtitle>
                                </v-list-item>
                            </v-list>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>
<script>
export default {
    props: {
        subscription: {
            type: Object,
            required: true,
        }
    },
    computed: {
        products(){
            return this.subscription?.product_items || []
        },
    },
}
</script>
